// Basic helper functions for the site
import $ from 'jquery';
import * as Constants from "./constants";

export const initSite = () => {
  console.log("Site->initSite");
  $("#main-left-close-panel").click(function () { closeSidebarPanel(); });
  $("#main-left-open-panel").click(function () { openSidebarPanel(); });

  $("#map-left-show-parcel-search").click(function () { showParcelSearchContainer(); });
  $("#header-right-toolbar-search").click(function () { toggleParcelSearchContainer(); });
  $("#header-right-toolbar-print").click(function () { togglePrintContainer(); });
  $("#header-right-toolbar-about").click(function () { window.open(Constants.aboutUrl); });
  //$("#header-right-toolbar-basemap").click(function () { toggleBasemapGallery(); });
  $("#header-right-menu").click(function () { toggleMenuContent(); });
  $("#header-right-menu-search").click(function () { showParcelSearch(); });
  // $("#header-right-menu-basemap").click(function () { showBasemapGallery(); });
  $("#header-right-menu-print").click(function () { showCreateReport(); });
  $("#header-right-menu-about").click(function () { window.open(Constants.aboutUrl); });
}

export const closeSidebarPanel = () => {
  $("#main-left").width(0);
  $("#main-right").width("100%");
  $("#map-navigation").css("left", 0);
  $("#map-zoom-level").css("left", 0);
  $("#main-left-close-panel").hide();
  $("#main-left-open-panel").show();
};

export const openSidebarPanel = () => {
  let left = "325px";
  $("#main-left").width(left);
  $("#main-right").width("calc(100vw - 325px)");
  $("#map-navigation").css("left", left);
  $("#map-zoom-level").css("left", left);
  $("#main-left-open-panel").hide();
  $("#main-left-close-panel").show();
};

export const displayMessage = (div, msg) => {
  $(div + "-message").html(msg);
  $(div + "-message").show();
  $(div + "-error").hide();
};
export const addToDisplayMessage = (div, msg, newLine) => {
  let elem = div + "-message";
  let crntMsg = $(elem).html();
  if (newLine) crntMsg += "</br>";
  $(elem).html(crntMsg + msg);
};
export const displayError = (div, msg) => {
  $(div + "-error").html(msg);
  $(div + "-error").show();
  $(div + "-message").hide();
};
export const hideInfo = (div) => {
  $(div + "-message").hide();
  $(div + "-error").hide();
};
export const iFrameDataUriTest = function (src) {
  let support, iframe = document.createElement('iframe');

  iframe.style.display = 'none';
  iframe.setAttribute('src', src);

  document.body.appendChild(iframe);

  try {
    support = !!iframe.contentDocument;
  } catch (e) {
    support = false;
  }

  document.body.removeChild(iframe);

  return support;
};

export const toggleBasemapGallery = () => {
  if ($("#main-search-container").is(":visible")) toggleParcelSearchContainer();
  if ($("#main-print-container").is(":visible")) togglePrintContainer();

  if ($("#main-basemap-gallery-container").is(":visible")) {
    $("#header-right-toolbar-basemap").removeClass("toolbar-option-selected");
    $("#main-basemap-gallery-container").hide();
  } else {
    $("#header-right-toolbar-basemap").addClass("toolbar-option-selected");
    $("#main-basemap-gallery-container").show();
  }
};

export const toggleParcelSearchContainer = () => {
  if ($("#main-basemap-gallery-container").is(":visible")) toggleBasemapGallery();
  if ($("#main-print-container").is(":visible")) togglePrintContainer();

  if ($("#main-search-container").is(":visible")) {
    $("#header-right-toolbar-search").removeClass("toolbar-option-selected");
    $("#main-search-container").hide();
  } else {
    $("#header-right-toolbar-search").addClass("toolbar-option-selected");
    $("#main-search-container").show();
  }
};
export const showParcelSearchContainer = () => {
  if ($("#main-search-container").is(":visible")) return;
  toggleParcelSearchContainer();
}

export const togglePrintContainer = () => {
  if ($("#main-basemap-gallery-container").is(":visible")) toggleBasemapGallery();
  if ($("#main-search-container").is(":visible")) toggleParcelSearchContainer();

  if ($("#main-print-container").is(":visible")) {
    $("#header-right-toolbar-print").removeClass("toolbar-option-selected");
    $("#main-print-container").hide();
  } else {
    $("#header-right-toolbar-print").addClass("toolbar-option-selected");
    $("#main-print-container").show();
  }
};
export const hidePrintButton = () => {
  $("#header-right-menu-print").hide();
  $("#header-right-toolbar-print").hide();
  if ($("#main-print-container").is(":visible")) {
    $("#header-right-toolbar-print").removeClass("toolbar-option-selected");
    $("#main-print-container").hide();
  }
}

function toggleMenuContent() {
  if ($("#header-right-menu-content").is(":visible")) {
    $("#header-right-menu-content").hide();
  } else {
    $("#main-search-container").hide();
    $("#main-basemap-gallery-container").hide();
    $("#main-print-container").hide();
    $("#header-right-menu-content").show();
  }
}

function showParcelSearch() {
  $("#header-right-menu-content").hide();
  $("#main-search-container").show();
}

function showBasemapGallery() {
  $("#header-right-menu-content").hide();
  $("#main-basemap-gallery-container").show();
}

function showCreateReport() {
  $("#header-right-menu-content").hide();
  $("#main-print-container").show();
}
